<template>
    <div class="h5inviter">
        <img src="../assets/logo@1x.png" alt="" class="logo">
        <div class="content">
            <el-form :model="ruleForm" status-icon label="top" :rules="rules" ref="ruleForm" class="demo-ruleForm">

                <el-form-item label="Name" prop="name">
                    <el-input v-model="ruleForm.name" placeholder="Please enter your Name"></el-input>
                </el-form-item>

                <el-form-item label="Nationality" prop="nationality">
                    <el-input v-model="ruleForm.nationality" placeholder="Please enter your Nationality"></el-input>
                </el-form-item>

                <el-form-item label="Phone Number" class="phoneitem" prop="nationality" style="">
                    <!-- <div> -->
                    <el-select style="display: inline-block;width: 50%;" v-model="ruleForm.areaCode" collapse-tags
                        @change="changeCode">
                        <div class="el-input_search">
                            <img src="../assets/search.svg" /><input type="text" placeholder="Search Area Code"
                                class="el-input__inner" v-model="dropDownValue" @keyup="dropDownSearch">
                        </div>
                        <el-option v-for="item in areaCodeData" :key="item.id"
                            :label="'+' + item.country_code + ' ' + item.title" :value="item.id">+{{ item.country_code
                            }}
                            {{ item.title }}</el-option>
                    </el-select>
                    <el-input oninput="value=value.replace(/\D/gi,'')" autocomplete="off" :maxlength="max"
                        v-model="ruleForm.mobile" placeholder="Please enter your Phone Number"></el-input>
                </el-form-item>

                <el-form-item label="Email" prop="email">
                    <el-input v-model="ruleForm.email" placeholder="Please enter your Email"></el-input>
                </el-form-item>

                <el-form-item label="" prop="" class="emailcode">
                    <el-input v-model="ruleForm.code" placeholder="Input Verification code"></el-input>
                    <el-button class="borderBtn codebtn" @click="countDownE()"
                        v-if="maxTotaltimeE == setTimeE || setTimeE == 0">Send</el-button>
                    <el-button class="borderBtn codebtn" v-else>Resend Code (<span>{{ setTimeE }}</span>s)</el-button>
                </el-form-item>

                <el-form-item label="Invitation code" prop="last_name">
                    <el-input v-model="ruleForm.invite_code" placeholder="Please enter your Invitation code"></el-input>
                </el-form-item>

                <el-form-item label="" prop="">
                    <el-button style="margin-top: 12px;width: 100%;background-color: #ff904d;color: #fff;"
                        class="Confirmbtn1" @click="Submission('ruleForm')">Submission</el-button>
                </el-form-item>

            </el-form>
        </div>
        <div v-if="showDialog" class="showDialog">
            <p>We have created a teacher account for you. Please use your phone number and password Log in to the
                teacher portal website. Thank you for your support！</p>
            <el-button style="background-color: #ff904d;width: 80%;color: #fff;margin-top: 15px;"
                @click.stop.prevent="toIndex">OK</el-button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'h5inviter',
    data() {
        return {
            ruleForm: {
                name: '',
                nationality: '',
                mobile: '',
                areaCode: '',
                country_code: '',
                email: '',
                code: '',
                invite_code: '',
                time_zone: ''
            },
            rules: {},
            areaCodeData: [],
            dropDownValue: '',
            max: 10,
            qvhao: [],
            timerE: null,//定时器
            setTimeE: 60,//定时器
            maxTotaltimeE: 60, //定时器
            showDialog: false
        }
    },
    created() {
        // 获取国家区号
        this.getCountryCode()
    },
    methods: {
        toIndex() {
            this.$router.push({ path: '/' })
        },
        // 倒计时
        setCountE(setTime) {
            if (setTime >= 0) {
                if (!this.timerE) {
                    this.timerE = setInterval(() => {
                        if (this.setTimeE > 0 && this.setTimeE <= this.maxTotaltimeE) {
                            this.setTimeE--
                        } else {
                            clearInterval(this.timerE)
                            this.timerE = null
                            this.setTimeE = 60
                        }
                    }, 1000)
                }
            }
        },
        countDownE() {
            console.log(this.ruleForm);

            if (!this.ruleForm.email) {
                this.$message({
                    message: 'Email cannot be empty.',
                    type: 'warning'
                })
                return false
            }
            if (this.maxTotaltimeE == this.setTimeE) {
                this.$http.post('/tutor/api/sendEmailCode', {
                    email: this.ruleForm.email,
                }).then((res) => {
                    if (res.data.code == 200) {
                        this.$message({
                            message: 'send successfully',
                            type: 'success'
                        })
                        this.setCountE(this.setTimeE)
                    } else {
                        this.$message({
                            message: res.data.msg,
                            type: 'warning'
                        })
                    }
                }).catch((error) => {
                    console.log(error) // 请求失败返回的数据
                })
            }
        },
        Submission(formName) {

            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.ruleForm.time_zone = this.utils.getTimeZoneCity()
                    this.$http.post('/tutor/api/ftRegist', this.ruleForm).then(res => {
                        if (res.data.code == 200) {

                            this.$message.success('Saved successfully!')
                            this.showDialog = true
                        } else {
                            this.$message.error(res.code.msg)
                        }

                    }).cach(err => {
                        this.$message.error(err)

                    })
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });

        },
        changeCode() {
            this.areaCodeData.map((item) => {
                if (this.ruleForm.areaCode == item.id) {
                    this.ruleForm.country_code = item.country_code
                }
            });
            if (this.ruleForm.country_code == '86') {
                if (this.ruleForm.mobile.length > 11) {
                    this.ruleForm.mobile = ''
                }
                this.max = 11
            } else if (this.ruleForm.country_code == '1') {
                if (this.ruleForm.mobile.length > 10) {
                    this.ruleForm.mobile = ''
                }
                this.max = 10
            } else {
                this.max = 15
            }
        },
        dropDownSearch() {
            var _this = this
            if (_this.dropDownValue) {
                _this.areaCodeData = []
                _this.qvhao.find(item => {
                    let name = ' +' + item.country_code + item.title
                    if (name.indexOf(_this.dropDownValue) != -1) {
                        _this.areaCodeData.push(item)
                    }
                })
            } else {
                _this.areaCodeData = _this.qvhao
            }
        },    // 国家区号
        getCountryCode() {
            this.$http.get('/api/dict/countries?page=1&pagesize=999&keywords=&country_code=').then((res) => {
                console.log(res)
                this.qvhao = res.data.data
                this.areaCodeData = res.data.data
                this.ruleForm.areaCode = this.areaCodeData[0].id
                this.ruleForm.country_code = this.areaCodeData[0].country_code
            })
        },
    }
}
</script>

<style lang="less" scoped>
.showDialog {
    position: absolute;
    top: 0;
    background: #fff;
    border-radius: 16px;
    padding: 12px;
    margin: 30vh 7%;
    width: 80%;
    z-index: 9999;
    box-shadow: 0 0 0 500px rgba(0, 0, 0, 0.7);
}

.h5inviter {
    background-image: url('../assets/h5_bg.png');
    width: 100vw;
    height: 100vh;
    text-align: center;

}

.logo {
    display: inline-block;
    margin-top: 35px;
}

.content {
    padding: 16px;
}

.el-form-item {
    margin-bottom: 0 !important;
}

/deep/.emailcode {
    margin-top: 8px;

    .el-form-item__content {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;

        .el-button {
            margin-left: 16px;
            color: #fff;
            background-color: #ff904d;
            border: 1px solid #FFF;
        }
    }
}

/deep/.phoneitem {
    display: flex;
    align-items: flex-start;
    flex-direction: column;

    .el-form-item__content {
        display: flex;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/shareRegister.vue